/**
 * Created by Languagenut on 18/04/2019.
 */

 
import React  from 'react';
import Base from './edit_comfirmation_step.js';
import { ProgressBar , Button, Row, Col , Alert} from 'react-bootstrap'
import FieldGroup from '../../FieldGroup.js'
import Summary from './assignment_summary.js';
import { DateRangePicker} from 'react-dates';
import GeneralTable from '../../general_table.js';
import Translation from '../../../store/internationalization-store.js'
import moment from 'moment';
import Checkbox from '../../checkbox.js';
import InformationPopup from '../../popup/information_popup.js'

class Comfirmation extends Base.component {

    constructor(props) {
        super();
    }


    render(){

        var columns = [
            {
                dataField: 'name',
                text: Translation.get(827,'Student Name'),
            },
            {
                dataField: 'classes',
                text: Translation.get(830,'Classes'),
                sort: true,
                align: "left",
            },
            {
                dataField: 'rank',
                text: Translation.get(22,'Username'),
                sort: true,
                align: "left",
            },
            {
                dataField: 'rank',
                text: Translation.get(23,'Password'),
                sort: true,
                align: "left",
            },

        ];

        var columns = [
            {
                dataField: 'name',
                sort: true,
                text: Translation.get(819 , 'Class Name'),
            },{
                dataField: 'students',
                text: Translation.get(498 , 'Assign To'),
                align: "left",
                style:{
                    width:'60%'
                },
                formatter:function(cell , row){
                    return this.renderStudentsSelect(row)
                }.bind(this)
            }
        ];

        var AdvanceButton2 = React.createElement(Button, {
            onClick: function() { this.handleHomeworkSubmission.bind(this)().then(function(homeWorkUid){
                window.location.hash = "#/assignments/overview/"+homeWorkUid;
            }.bind(this)) }.bind(this),
            bsStyle:'primary',
            className:"btn-block",
            disabled:this.checkIsNotCorrect()
        },Translation.get(12724 , 'Save & Exit'));


        if(!this.state.loaded)
            return <ProgressBar animated now={45} />;

        let repatable =  <div style={{marginTop:"10px", marginLeft:'0px'}} >
            <span style={{float:"left"}} onClick={this.handelSelectRepeatable.bind(this)}><Checkbox checked={this.state.isRepeatable} isDisabled label={<span>{Translation.get(2431 ,'Repeat Assignment')}&nbsp;&nbsp;</span>} className="float-left" type="checkbox"  /></span>
            <span><i onClick={()=>{this.setState({information:true})}} class="fas fa-info-circle"></i></span></div>;

        let alert = null;

        if(this.state.startDate)
        {
            if(this.state.startDate.isAfter(moment()))
            {
                alert = <Alert style={{marginTop:'10px'}} variant={'warning'} >
                    { Translation.get('0' , 'This assignment is set to start in the future and will not be visible to your students until the set date')}
                </Alert>
            }
        }

        if (window.location.hash.indexOf("/edit") > -1) {
            this.handleHomeworkSubmission().then(function(homeWorkUid){
                if (window.location.hash == "#/assignments/edit/"+homeWorkUid) {
                    window.location.reload();
                } else {
                    window.location.hash = "#/assignments/edit/"+homeWorkUid;
                }
            }.bind(this));
            return "";
        }

        var checkBoxStuff =  <span style={{paddingBottom:"10px"}} className="float-right" onClick={function() {
            var isAll = !this.state.isAll
            this.setState({isAll:isAll});
        }.bind(this)}> {Translation.get(12791, 'Show all Classes')}
            <Checkbox isDisabled checked={this.state.isAll}/></span>

        var dataUsed = this.state.classes;

        if (!this.state.isAll) {
            dataUsed = this.state.classMine;
        }

        var classData = <GeneralTable secondary={checkBoxStuff} hideDownload component={AdvanceButton2} columns={columns} data={dataUsed} />;
        if (this.state.classLoading == false) {
            classData = <ProgressBar animated now={45} />
        }

        return <div>
            <InformationPopup title={Translation.get(12718 , ' About Repeatable Assignments')} show={this.state.information} onHide={()=>{this.setState({information:false})}}>
                {Translation.get(12719, 'The repeat assignment function allows your students to retake an assignment as many times as they wish to. If this is unticked, students will only be given one attempt.')}
            </InformationPopup>
            <Row>
                <Col md={12}>
                    <Row>
                        <Col md={8}>
                            <Row>
                                <Col md={12}><FieldGroup value={this.state.homeworkName} id="name" autofocus={true} label={Translation.get(2008,'Assignment Name')}  onChange={(event)=>{this.setState({homeworkName:event.target.value})}}/></Col>
                                <Col md={12}>
                                    <FieldGroup value={this.state.comment} style={{"resize":"none"}} as="textarea" rows="4" label={Translation.get(2432 ,'Add instructions/comments for this assignment which will be visible to students')}  onChange={(event)=>{this.setState({comment:event.target.value})}}/>
                                </Col>
                                <Col md={"auto"} style={{marginTop:"auto", marginBottom:"auto"}} >{Translation.get(2433 ,'Start Date - Due Date')}</Col>
                                <Col md={"auto"} style={{marginTop:"auto", marginBottom:"auto"}} >
                                    <DateRangePicker
                                        displayFormat='DD/MM/YYYY'
                                        className="hellp"
                                        customArrowIcon={<i class="fas fa-arrows-alt-h"></i>}
                                        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                                        startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                                        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                                        endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                                        onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                                        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                        onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                        />
                                </Col>
                                <Col style={{marginTop:"auto", marginBottom:"auto"}} md={5} >
                                    {repatable}
                                </Col>
                                <Col md={12}>{alert}</Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div  style={{marginBottom:'8px'}}>{Translation.get(12725 , 'New Tasks')}</div>
                            <Summary types={this.props.data.types}/>
                        </Col>

                    </Row>
                    <Row>
                        <Col md={12}>
                            <hr/>
                            {classData}
                        </Col>

                    </Row>
                </Col>

            </Row>
            <Row>
                <Col sm={6}></Col>
                <Col sm={6}>{AdvanceButton2}</Col>
            </Row>
        </div>
    }

}


export default {
    name: function() {return Translation.get(2434 ,'Edit Existing')},
    icon:<i class="fa-2x fas fa-file-alt"></i>,
    title:null,
    disableButtons:true,
    onSubmit: function (done){
        done();
    },
    component: Comfirmation
}